module.exports = __webpack_public_path__ + "img/font-size-design-tokens.252ab596.png";